// extracted by mini-css-extract-plugin
export default {"chatBubble":"ChatBubble_chatBubble__j3+u4","chatIcon":"ChatBubble_chatIcon__t-mWG"};